const API_ENDPOINTS = {
    FETCH_USERS: "/auth/users",
    FETCH_SETTINGS: "/debug/app-config",
    UPDATE_SETTINGS: "/debug/app-config",
}

export default API_ENDPOINTS;